export enum LoginError {
  NotAuthorized,
  NetworkError,
  TooManyAttempts,
  UserDisabled,
  UserNotConfirmed,
  UserNotFound,
  Unknown
}
